import axios from "axios";
import TokenService from "./userStorage";

// const baseURL = `http://localhost:8000`;
// const baseURL = process.env.React_App_Base_URL;
const baseURL = `https://golancer.tech`;
const instance = axios.create({
  baseURL: baseURL,
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    config.headers["Authorization"] = token ? `Bearer ${token}` : "";
    config.headers["SECRET"] = "SECRETAPIKEYGolancer**1";
    return config;
  },
  (error) => {
    return Promise.reject("error:", error);
  }
);

export default instance;
